import React from 'react';

interface BadgeIconProps {
  size?: number;
  className?: string;
  color?: string;
}

// First Quiz - Quiz/Test icon
export const FirstQuizIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M14 2V8H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M8 12H16" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 16H12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Perfect Score - Star icon
export const PerfectScoreIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill={color}/>
  </svg>
);

// Sub-Quiz Master - Trophy icon
export const SubQuizMasterIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9C6 6.79086 7.79086 5 10 5H14C16.2091 5 18 6.79086 18 9V10C18 12.2091 16.2091 14 14 14H13V16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16H11V14H10C7.79086 14 6 12.2091 6 10V9Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M12 2V5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 18V22" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Global #1 - Globe/Earth icon
export const GlobalOneIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M2 12H22" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2C15.0376 2 17.798 3.15893 19.6142 5.06189C19.8011 5.27722 19.9761 5.50188 20.139 5.73509C20.3031 5.96957 20.4551 6.21247 20.5946 6.46284C20.7356 6.71549 20.8637 6.9756 20.9781 7.24211C21.0936 7.51098 21.1953 7.78623 21.2831 8.06689C21.3702 8.34509 21.4432 8.6286 21.5021 8.91611C21.5603 9.20198 21.6043 9.49173 21.6342 9.78422C21.6646 10.0791 21.6806 10.3764 21.6821 10.6744C21.6827 10.8244 21.6787 10.9744 21.6701 11.1244C21.6619 11.2722 21.6491 11.4196 21.6317 11.5664C21.6146 11.7116 21.5929 11.856 21.5667 12H21.5667" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2C8.96243 2 6.20197 3.15893 4.3858 5.06189C4.19893 5.27722 4.02388 5.50188 3.86098 5.73509C3.69688 5.96957 3.54488 6.21247 3.40543 6.46284C3.26443 6.71549 3.13627 6.9756 3.02186 7.24211C2.90643 7.51098 2.80472 7.78623 2.71689 8.06689C2.62975 8.34509 2.55675 8.6286 2.49786 8.91611C2.43972 9.20198 2.39572 9.49173 2.3658 9.78422C2.33543 10.0791 2.31943 10.3764 2.31786 10.6744C2.31725 10.8244 2.32125 10.9744 2.32986 11.1244C2.33806 11.2722 2.35088 11.4196 2.36827 11.5664C2.38543 11.7116 2.40706 11.856 2.43327 12H2.43327" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Monthly 1st Place - Calendar with trophy
export const MonthlyFirstIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 14L13.5 16L16 13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Weekly 2nd Place - Calendar with medal
export const WeeklySecondIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="16" r="3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M12 14V16L13 17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Daily 1st Place - Calendar with trophy
export const DailyFirstIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 14L10.5 16L15 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Daily 2nd/3rd Place - Calendar with number
export const DailyPlaceIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="16" r="3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Weekly 1st Place - Calendar with trophy
export const WeeklyFirstIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 14L10.5 16L15 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Weekly 3rd Place - Calendar with medal
export const WeeklyThirdIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="16" r="3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Monthly 2nd/3rd Place - Calendar with medal
export const MonthlyPlaceIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M16 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 2V6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 10H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="16" r="3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Quiz Streak - Flame outline icon (formerly Login Streak)
export const LoginStreakIcon: React.FC<BadgeIconProps> = ({ size = 24, className, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 14.5C8.5 16.433 10.067 18 12 18C13.933 18 15.5 16.433 15.5 14.5C15.5 12.567 13.933 11 12 11C10.067 11 8.5 12.567 8.5 14.5Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2C10.5 4 9 5.5 9 8C9 9.5 9.5 10.5 10.5 11.5C11 12 11.5 12.5 12 13.5C12.5 12.5 13 12 13.5 11.5C14.5 10.5 15 9.5 15 8C15 5.5 13.5 4 12 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 13C7 12.5 6 11.5 6 10C6 8.5 6.5 7.5 7.5 7C8 6.5 8.5 6.5 9 7C9.5 7.5 10 8.5 10 10C10 11.5 9.5 12.5 8 13Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 13C17 12.5 18 11.5 18 10C18 8.5 17.5 7.5 16.5 7C16 6.5 15.5 6.5 15 7C14.5 7.5 14 8.5 14 10C14 11.5 14.5 12.5 16 13Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Helper function to get the appropriate icon component for a badge
export const getBadgeIcon = (badgeName: string): React.FC<BadgeIconProps> | null => {
  const name = badgeName.toLowerCase();
  
  if (name.includes('first quiz')) {
    return FirstQuizIcon;
  } else if (name.includes('perfect score')) {
    return PerfectScoreIcon;
  } else if (name.includes('sub-quiz master') || name.includes('sub quiz master')) {
    return SubQuizMasterIcon;
  } else if (name.includes('global #1') || name.includes('global')) {
    return GlobalOneIcon;
  } else if (name.includes('daily')) {
    if (name.includes('1st') || name.includes('first')) {
      return DailyFirstIcon;
    } else {
      return DailyPlaceIcon;
    }
  } else if (name.includes('weekly')) {
    if (name.includes('1st') || name.includes('first')) {
      return WeeklyFirstIcon;
    } else if (name.includes('2nd') || name.includes('second')) {
      return WeeklySecondIcon;
    } else {
      return WeeklyThirdIcon;
    }
  } else if (name.includes('monthly')) {
    if (name.includes('1st') || name.includes('first')) {
      return MonthlyFirstIcon;
    } else {
      return MonthlyPlaceIcon;
    }
  } else if (name.includes('quiz streak') || name.includes('login streak')) {
    return LoginStreakIcon;
  }
  
  return null;
};

